<template>
    <div class="col-span-2 md:col-span-4 justify-end">
          <div class="flex justify-end gap-4 md:gap-5">
            <a href="https://gravaa.myshopify.com/account" class="hidden md:inline self-end" aria-label="Login">
              <IconUser :color="iconColor"/>
            </a>
            
            <IconSearch class="cursor-pointer self-end" @click="$emit('toggleSearch')" :color="iconColor"/>
            
            <NuxtLink to="/cart" class="self-end" aria-label="Go to Cart">
              <IconCart :color="iconColor" :qty="cartStore.totalItems"/>
            </NuxtLink>
            <button aria-label="Menu" @click="$emit('toggleMobileMenu')" class="block md:hidden pt-2">                 
             <IconBurgerlines :color="iconColor"/>
            </button>
          </div>                  
        </div>

</template>
<script setup>

defineProps({
    cartStore: {
        type: Object,
        required: true
    },
    iconColor: {
        type: String,
        required: true
    }
});

</script>